import moment from "moment";
import Select from "react-select";
import { CSVLink } from "react-csv";
import React, { Component } from "react";
import {
  Card,
  CardBody,
  Label,
  Input,
  Row,
  Col,
  Button,
  Form,
  UncontrolledCollapse,
} from "reactstrap";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { getAuthUser } from "../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { GlobalContext } from "../components/Layout/MainLayout";
let user = {};

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: new Date().setUTCDate(1),
      toDate: new Date(),
      status: "all",
      type: "all",
      showLoader: false,
      filterCollapse: true,
      Camps: [],
      selectedCamp: [],
      parentEvents: [],
      selectedParentEvent: {},
      transactionCSVHeaders: [],
      transactionCSVData: [],
      pendingBalanceCSVHeaders: [],
      pendingBalanceCSVData: [],
    };
  }

  componentDidMount() {
    user = getAuthUser();
    user.connectedUser && user.connectedUser.SPIEvent
      ? this.getSPIEvents()
      : this.getCamps();
  }

  getCamps = async () => {
    try {
      this.setState({
        showLoader: true,
        transactionCSVHeaders: [],
        transactionCSVData: [],
      });
      let response = await Server.request({
        url: `camp/web/list?parentEventId=${this.state.selectedParentEvent.value}`,
        method: "GET",
      });
      if (response) {
        if (response.camps && response.camps.length) {
          this.setState({
            showLoader: false,
            Camps: response.camps,
            selectedCamp: [
              {
                value: "all",
                label: "All",
              },
            ],
            limit: this.context.limit,
          });
        } else {
          this.setState({
            showLoader: false,
            Camps: [],
            limit: this.context.limit,
          });
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getSPIEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/rushNational/camps",
        method: "GET",
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            parentEvents: response.camps,
            selectedParentEvent: {
              value: response.camps[0]._id,
              label: response.camps[0].name,
            },
          },
          () => this.getCamps()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadTransactionAllRecords = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let allcamps = this.state.selectedCamp.find(
        (camp) => camp.value === "all"
      );
      let campIds = allcamps
        ? this.state.Camps.map((camp) => camp._id)
        : this.state.selectedCamp.map((camp) => camp.value);
      let response = await Server.request({
        url: "rushsoccer/download/transaction/allRecords",
        method: "POST",
        data: {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          type: this.state.type,
          status: this.state.status,
          campIds,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          transactionCSVHeaders: response.transactionCSVHeaders,
          transactionCSVData: response.transactionCSVData,
        });
      }
      this.csvLink.link.click();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadAllPlayersPendingBalance = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let allcamps = this.state.selectedCamp.find(
        (camp) => camp.value === "all"
      );
      let campIds = allcamps
        ? this.state.Camps.map((camp) => camp._id)
        : this.state.selectedCamp.map((camp) => camp.value);
      let response = await Server.request({
        url: "rushsoccer/download/pendingBalance/allPlayers",
        method: "POST",
        data: {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          type: this.state.type,
          status: this.state.status,
          campIds,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          pendingBalanceCSVHeaders: response.pendingBalanceCSVHeaders,
          pendingBalanceCSVData: response.pendingBalanceCSVData,
        });
      }
      this.csvLink1.link.click();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page title="Reports" breadcrumbs={[{ name: "Reports", active: true }]}>
          <Card>
            <CardBody>
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <div>
                    <Button
                      color="primary"
                      id="toggler1"
                      style={{ width: "50%", marginBottom: "1rem" }}
                      onClick={() => {
                        this.setState({
                          filterCollapse: !this.state.filterCollapse,
                        });
                      }}
                    >
                      Filters
                    </Button>
                  </div>
                  <UncontrolledCollapse
                    toggler="#toggler1"
                    isOpen={this.state.filterCollapse}
                  >
                    <Card>
                      <CardBody>
                        <Form
                          className="form"
                          onSubmit={(event) => this.getTransactions(event)}
                        >
                          <Row>
                            <Col md={6}>
                              <Label>From Date:</Label>
                              <Input
                                type="date"
                                name="fromDate"
                                required
                                placeholder="fromDate"
                                defaultValue={
                                  moment(new Date(this.state.fromDate)).format(
                                    "YYYY-MM-DD"
                                  ) || ""
                                }
                                onChange={(event) => {
                                  event.persist();
                                  this.setState({
                                    fromDate: event.target.value,
                                  });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              <Label>To Date:</Label>
                              <Input
                                type="date"
                                name="toDate"
                                required
                                placeholder="toDate"
                                defaultValue={
                                  moment(new Date(this.state.toDate)).format(
                                    "YYYY-MM-DD"
                                  ) || ""
                                }
                                onChange={(event) => {
                                  event.persist();
                                  this.setState({ toDate: event.target.value });
                                }}
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={3}>
                              <Label> Status:</Label>
                              <div>
                                <select
                                  className="btn selectCss"
                                  value={this.state.status}
                                  onChange={(event) =>
                                    this.setState({
                                      status: event.target.value,
                                    })
                                  }
                                  style={{ width: "100%" }}
                                >
                                  <option value="all">All</option>
                                  <option value="pending">Pending</option>
                                  <option value="paid">Paid</option>
                                  <option value="failed">Failed </option>
                                  <option value="cancelled">Cancelled</option>
                                  <option value="refund">Refund</option>
                                </select>
                              </div>
                            </Col>
                            <Col md={3}>
                              <Label> Type:</Label>
                              <div>
                                <select
                                  className="btn selectCss"
                                  value={this.state.type}
                                  onChange={(event) =>
                                    this.setState({
                                      type: event.target.value,
                                    })
                                  }
                                  style={{ width: "100%" }}
                                >
                                  <option value="all">All</option>
                                  <option value="fullPayment">
                                    Full Payment
                                  </option>
                                  <option value="installments">
                                    Installments
                                  </option>
                                  <option value="subscriptions">
                                    Subscriptions
                                  </option>
                                </select>
                              </div>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              {user.connectedUser &&
                                user.connectedUser.SPIEvent && (
                                  <>
                                    <Label for="name">Select Event :</Label>
                                    <Select
                                      value={this.state.selectedParentEvent}
                                      options={[
                                        ...this.state.parentEvents.map(
                                          (parentEvent) => ({
                                            value: parentEvent._id,
                                            label: parentEvent.name,
                                          })
                                        ),
                                      ]}
                                      onChange={(result) =>
                                        this.setState(
                                          {
                                            selectedParentEvent: result,
                                          },
                                          () => this.getCamps()
                                        )
                                      }
                                    />
                                  </>
                                )}
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col md={6}>
                              <Label for="name1">Event :</Label>
                              <Select
                                isMulti
                                placeholder="Select Event"
                                closeMenuOnSelect={false}
                                value={this.state.selectedCamp}
                                options={[
                                  {
                                    value: "all",
                                    label: "All",
                                  },
                                  ...this.state.Camps.map((camp) => ({
                                    value: camp._id,
                                    label: camp.name,
                                  })),
                                ]}
                                onChange={(result) =>
                                  this.setState({
                                    selectedCamp: result,
                                  })
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3"></Row>
                          <Row className="mt-3">
                            <Col xl={12} lg={12} md={12}>
                              <Button
                                className="mr-3 mb-3"
                                onClick={() =>
                                  this.setState({
                                    monthDate: new Date(),
                                    status: "all",
                                    type: "all",
                                    selectedCamp: [
                                      {
                                        value: "all",
                                        label: "All",
                                      },
                                    ],
                                  })
                                }
                              >
                                Reset Filter
                              </Button>
                              <Button
                                className="mr-3 mb-3"
                                onClick={(event) =>
                                  this.downloadTransactionAllRecords(event)
                                }
                              >
                                Download all transactions
                              </Button>
                              <CSVLink
                                className="text-white"
                                style={{ textDecoration: "unset" }}
                                filename={`transactions.csv`}
                                data={this.state.transactionCSVData}
                                headers={this.state.transactionCSVHeaders}
                                ref={(ref) => {
                                  this.csvLink = ref;
                                }}
                              ></CSVLink>
                              <Button
                                className="mr-3 mb-3"
                                onClick={(event) =>
                                  this.downloadAllPlayersPendingBalance(event)
                                }
                              >
                                Download pending balance
                              </Button>
                              <CSVLink
                                className="text-white"
                                style={{ textDecoration: "unset" }}
                                filename={`transactions.csv`}
                                data={this.state.pendingBalanceCSVData}
                                headers={this.state.pendingBalanceCSVHeaders}
                                ref={(ref) => {
                                  this.csvLink1 = ref;
                                }}
                              ></CSVLink>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
Report.contextType = GlobalContext;
export default Report;
